// extracted by mini-css-extract-plugin
module.exports = {"root":"rich-text-area_root__9ZLj3","content":"rich-text-area_content__UZDGG","socialLinks":"rich-text-area_socialLinks__Dfw4e"};